module.exports = __webpack_public_path__ + "img/MEGA.b644be62.png";